export default __webpack_public_path__ + "static/media/logo.b146b0a0.svg";